import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  flex: 1;
  flex-direction: column;
  background-color: var(--neutral-theme);
`
